const topics = [
  { name: '红桃视频', heat: '98.6万', tag: '热门', color: 'primary' },
  { name: '西瓜视频免费', heat: '87.2万', tag: '推荐', color: 'accent' },
  { name: '小蓝视频', heat: '76.5万', tag: '新番', color: 'secondary' },
  { name: '茄子视频', heat: '65.8万', tag: '热播', color: 'primary' },
  { name: '久久视频', heat: '54.3万', tag: '经典', color: 'accent' },
  { name: '芒果视频', heat: '48.9万', tag: '独家', color: 'secondary' },
  { name: '高清影院', heat: '42.1万', tag: '高清', color: 'primary' },
  { name: '日韩剧场', heat: '38.7万', tag: '热追', color: 'accent' },
  { name: '欧美大片', heat: '35.2万', tag: '精选', color: 'secondary' },
];

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const tagBorderMap: Record<string, string> = {
  primary: 'border-primary-200',
  accent: 'border-accent-200',
  secondary: 'border-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            大家都在搜的话题标签
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            发现当下最受欢迎的视频频道与内容分类，紧跟热度不迷路
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#index"
              className={`group flex items-center justify-between p-4 md:p-5 rounded-xl border ${tagBorderMap[topic.color]} bg-background-50 hover:bg-background-100 transition-all cursor-pointer`}
            >
              <div className="flex items-center gap-3 min-w-0">
                <span className={`px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${tagColorMap[topic.color]}`}>
                  {topic.tag}
                </span>
                <span className="text-sm font-medium text-foreground-800 truncate whitespace-nowrap">
                  {topic.name}
                </span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0 ml-2">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">{topic.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}